// extracted by mini-css-extract-plugin
export var completionBody = "_ck-2";
export var completionCard = "_ck-0";
export var completionFooter = "_ck-3";
export var completionTitle = "_ck-1";